<template>
  
    <v-container class="fill-height" align="center" justify="center" fluid>
        <v-row>
          <v-text-field
            label="Email"
            name="email"
            prepend-icon="mdi-email"
            type="email"
            v-model="emailAdminToAdd"
          />
          <p>{{emailAdminToAdd}}</p>
          <v-btn @click="AddAsAdmin">AddAdmin</v-btn>
        </v-row>
        <Snackbar :text="snackbarText" :isopen="snackbarIsOpen" :color="snackbarColor" />
    </v-container>
</template>

<script>
import { fb } from "@/plugins/firebase.js";

export default {
  name: "AddAdmin",
  title: "AddAdmin",

  components: {
    Snackbar: () => import("@/components/Snackbar"),
  },

  data() {
    return {
      emailAdminToAdd: null,

      snackbarIsOpen: false,
      snackbarColor: 'success',
      snackbarText: '',
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    AddAsAdmin() {
      var addAdmin = fb.app().functions("europe-west1").httpsCallable("adminGrantAdminClaims");
      addAdmin({ email: this.emailAdminToAdd }).then(function (result) {
        // Read result of the Cloud Function.
        var sanitizedMessage = result.data.result;
        // console.log(sanitizedMessage);
        this.snackbarText = sanitizedMessage;
        this.snackbarIsOpen = true
      });
    },
  },
};
</script>

<style>
</style>







